import React from "react";
import Heading from "@arachnys/styleguide/Heading";
import { Row, Col } from "antd";

import { renderLinesOfBusiness } from "../../util";
import style from "./styles";
import EntityInfo from "./EntityInfo";
import { Entity } from "../../types";

const OrgViewer = ({ entity }: { entity: Entity }) => (
    <React.Fragment>
        <Heading level={0}>Basics</Heading>
        <Row>
            <Heading
                level={1}
                {...style.subheading}
                style={{ marginBottom: 35 }}
            >
                Basic Info
            </Heading>
            <Col md={12}>
                <EntityInfo
                    entity={entity}
                    label="Entity Name"
                    path={["name"]}
                />
                <EntityInfo
                    entity={entity}
                    label="Local Names"
                    path={["alternativeNames", "localNames"]}
                />
                <EntityInfo
                    entity={entity}
                    label="Previous Names"
                    path={["alternativeNames", "previousNames"]}
                />
                <EntityInfo
                    entity={entity}
                    label="Short Names"
                    path={["alternativeNames", "shortNames"]}
                />
            </Col>
            <Col md={12}>
                <Row>
                    <Col offset={10}>
                        <span {...style.title}>Entity Subtype: </span>
                        <span>{entity.subtype || "n/a"}</span>
                    </Col>
                </Row>
            </Col>
            <Row>
                <Col offset={1} xs={22}>
                    <hr {...style.divider} />
                </Col>
            </Row>
            {entity.corporateRegistry ? (
                <Row>
                    <Col offset={1} md={5}>
                        <span {...style.title}>Registry Authority:</span>
                        <span> {entity.corporateRegistry.authority}</span>
                    </Col>
                    <Col md={6}>
                        <span {...style.title}>
                            Corporate Registration Number:
                        </span>
                        <span>
                            {" "}
                            {entity.corporateRegistry.registrationNumber}
                        </span>
                    </Col>
                    <Col offset={1} md={4}>
                        <span {...style.title}>Registration Status:</span>
                        <span>
                            {" "}
                            {entity.corporateRegistry.registrationStatus}
                        </span>
                    </Col>
                    <Col md={3}>
                        <span {...style.title}>Date of Incorporation:</span>
                        <span>
                            {" "}
                            {entity.corporateRegistry.dateOfIncorporation}
                        </span>
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col offset={1} md={5}>
                        <span {...style.title}>Registration authority:</span>
                        <span> Unknown</span>
                    </Col>
                    <Col md={6}>
                        <span {...style.title}>
                            Corporate registration number:
                        </span>
                        <span> Unknown</span>
                    </Col>
                    <Col offset={1} md={4}>
                        <span {...style.title}>Registration status:</span>
                        <span> Unknown</span>
                    </Col>
                    <Col md={3}>
                        <span {...style.title}>Date of Incorporation:</span>
                        <span> Unknown</span>
                    </Col>
                </Row>
            )}

            <Row gutter={17} style={{ marginTop: 31 }}>
                <Col md={12}>
                    <Row>
                        <Heading
                            level={1}
                            {...style.subheading}
                            style={{ marginBottom: 35 }}
                        >
                            Registered Address
                        </Heading>
                        <Col offset={2} xs={5}>
                            <p {...style.title}>Street address:</p>
                            <p {...style.title}>City:</p>
                            <p {...style.title}>Postcode:</p>
                            <p {...style.title}>Country:</p>
                            <p {...style.title}>State:</p>
                        </Col>
                        <Col>
                            {entity.legalAddress != null && (
                                <React.Fragment>
                                    <p>
                                        {entity.legalAddress.streetAddress ||
                                            "Unknown"}
                                    </p>
                                    <p>
                                        {entity.legalAddress.city || "Unknown"}
                                    </p>
                                    <p>
                                        {entity.legalAddress.postalCode ||
                                            "Unknown"}
                                    </p>
                                    <p>
                                        {entity.legalAddress.countryCode ||
                                            "Unknown"}
                                    </p>
                                    <p>
                                        {entity.legalAddress.state || "Unknown"}
                                    </p>
                                </React.Fragment>
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col md={12}>
                    <Heading
                        level={1}
                        {...style.subheading}
                        style={{ marginBottom: 35 }}
                    >
                        Operational Address
                    </Heading>
                    <Col offset={2} xs={5}>
                        <p {...style.title}>Street address:</p>
                        <p {...style.title}>City:</p>
                        <p {...style.title}>Postcode:</p>
                        <p {...style.title}>Country:</p>
                        <p {...style.title}>State:</p>
                    </Col>
                    <Col>
                        {entity.physicalAddress != null ? (
                            <React.Fragment>
                                <p>
                                    {entity.physicalAddress.streetAddress ||
                                        "Unknown"}
                                </p>
                                <p>
                                    {entity.physicalAddress.city || "Unknown"}
                                </p>
                                <p>
                                    {entity.physicalAddress.postalCode ||
                                        "Unknown"}
                                </p>
                                <p>
                                    {entity.physicalAddress.countryCode ||
                                        "Unknown"}
                                </p>
                                <p>
                                    {entity.physicalAddress.state || "Unknown"}
                                </p>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <p>Unknown</p>
                                <p>Unknown</p>
                                <p>Unknown</p>
                                <p>Unknown</p>
                                <p>Unknown</p>
                            </React.Fragment>
                        )}
                    </Col>
                </Col>
            </Row>
        </Row>

        {entity.addresses && entity.addresses.length !== 0 ? (
            <>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Other Addresses
                </Heading>
                <Row gutter={10}>
                    <Col offset={1} xs={5} {...style.title}>
                        Address Type:
                    </Col>
                    <Col xs={5} {...style.title}>
                        Street Address:
                    </Col>
                    <Col xs={4} {...style.title}>
                        City:
                    </Col>
                    <Col xs={3} {...style.title}>
                        Postcode:
                    </Col>
                    <Col xs={3} {...style.title}>
                        Country:
                    </Col>
                    <Col xs={3} {...style.title}>
                        State:
                    </Col>
                </Row>
                {entity.addresses.map((address, i) => (
                    <Row style={{ marginTop: 15 }} gutter={10} key={i}>
                        <Col xs={5} offset={1}>
                            {address.type || "Unknown"}
                        </Col>
                        <Col xs={5}>{address.streetAddress || "Unknown"}</Col>
                        <Col xs={4}>{address.city || "Unknown"}</Col>
                        <Col xs={3}>{address.postalCode || "Unknown"}</Col>
                        <Col xs={3}>{address.countryCode || "Unknown"}</Col>
                        <Col xs={3}>{address.state || "Unknown"}</Col>
                    </Row>
                ))}
            </>
        ) : null}

        <Heading level={0} style={{ marginTop: 30 }}>
            Identifiers and Business Information
        </Heading>
        <Row gutter={17}>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    ID Numbers
                </Heading>
                <Row gutter={10}>
                    <Col offset={2} xs={5} {...style.title}>
                        Type:
                    </Col>
                    <Col xs={7} {...style.title}>
                        Number:
                    </Col>
                    <Col xs={4} {...style.title}>
                        Status:
                    </Col>
                    <Col xs={3} {...style.title}>
                        Start date:
                    </Col>
                    <Col xs={3} {...style.title}>
                        End date:
                    </Col>
                </Row>
                {entity.companyIdentifiers != null ? (
                    entity.companyIdentifiers.map(id => (
                        <Row
                            style={{ marginTop: 15 }}
                            gutter={10}
                            key={id.code}
                        >
                            <Col offset={2} xs={5}>
                                {id.identifier || "Unknown"}
                            </Col>
                            <Col xs={7}>{id.code || "Unknown"}</Col>
                            <Col xs={4}>{id.status || "Unknown"}</Col>
                            <Col xs={3}>{id.startDate || "Unknown"}</Col>
                            <Col xs={3}>{id.expiryDate || "Unknown"}</Col>
                        </Row>
                    ))
                ) : (
                    <Row style={{ marginTop: 15 }}>
                        <Col offset={2} xs={3}>
                            Unknown
                        </Col>
                        <Col xs={7}>Unknown</Col>
                        <Col xs={4}>Unknown</Col>
                        <Col xs={4}>Unknown</Col>
                        <Col xs={4}>Unknown</Col>
                    </Row>
                )}
                <Row>
                    <Col offset={1} xs={22}>
                        <hr {...style.divider} />
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col offset={2} xs={5} {...style.title}>
                        External ID:
                    </Col>
                    <Col xs={7} {...style.title}>
                        Type:
                    </Col>
                </Row>
                {entity.externalIdentifiers != null
                    ? entity.externalIdentifiers.map(e => (
                          <Row style={{ marginTop: 15 }} gutter={10} key={e.id}>
                              <Col offset={2} xs={5}>
                                  {e.id || "Unknown"}
                              </Col>
                              <Col xs={7}>{e.type || "Unknown"}</Col>
                          </Row>
                      ))
                    : null}
            </Col>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Business Information
                </Heading>
                <Row>
                    <Col offset={2} xs={6}>
                        <p {...style.title}>Risk Level:</p>
                        <p {...style.title}>Risk Score:</p>
                        <p {...style.title}>Business Relationship:</p>
                    </Col>
                    <Col>
                        <p>{entity.riskLevel || "Unknown"}</p>
                        <p>{entity.riskScore || "Unknown"}</p>
                        <p>{entity.businessRelationship || "Unknown"}</p>
                    </Col>
                </Row>
                <Row>
                    <Col offset={2} md={6}>
                        <span {...style.title}>Lines of Business: </span>
                    </Col>
                    <Col md={6}>
                        <span>
                            {renderLinesOfBusiness(entity.linesOfBusiness)}
                        </span>
                    </Col>
                </Row>
            </Col>
        </Row>

        <Heading level={0} style={{ marginTop: 30 }}>
            Ownership and Regulatory Information
        </Heading>
        <Row gutter={17}>
            <Col md={12}>
                <Heading level={1} style={{ marginBottom: 35 }}>
                    Ownership
                </Heading>
                <Row>
                    <Col offset={2} xs={10}>
                        <p {...style.title}>Ownership Type:</p>
                        <p {...style.title}>Exchange Traded Status:</p>
                    </Col>
                    <Col xs={10}>
                        <p>{entity.ownershipType}</p>
                        <p>{entity.exchangeTradedStatus}</p>
                    </Col>
                </Row>
                <Row>
                    <Col offset={2} xs={10}>
                        <p {...style.title}>Shares Outstanding:</p>
                        <p {...style.title}>Free Float:</p>
                        <p {...style.title}>Free Float %: </p>
                        <p {...style.title}>Stock Exchange Name:</p>
                    </Col>
                    <Col>
                        <p>{entity.sharesOutstanding || "Unknown"}</p>
                        <p>{entity.freeFloat || "Unknown"}</p>
                        <p>{entity.freeFloatPercentage || "Unknown"}</p>
                        <p {...style.title}>Exchange ID:</p>
                    </Col>
                </Row>
                {entity.stockExchanges ? (
                    entity.stockExchanges.map(e => (
                        <Row key={e.code}>
                            <Col offset={2} sm={10}>
                                <p>{e.name}</p>
                            </Col>
                            <Col sm={5}>
                                <p>{e.code}</p>
                            </Col>
                        </Row>
                    ))
                ) : (
                    <Row>
                        <Col offset={2} sm={10}>
                            <p>-</p>
                        </Col>
                        <Col>
                            <p>-</p>
                        </Col>
                    </Row>
                )}
            </Col>
            <Col md={12}>
                <Heading level={1} style={{ marginBottom: 35 }}>
                    Regulatory Information
                </Heading>
                <Row>
                    <Col offset={2} xs={6}>
                        <p {...style.title}>Regulation Status:</p>
                    </Col>
                    <Col>{entity.regulationStatus}</Col>
                </Row>
                <Row>
                    <Col offset={2} xs={10}>
                        <p {...style.title}>Regulation Body Name:</p>
                    </Col>
                    <Col>
                        <p {...style.title}>Regulatory ID:</p>
                    </Col>
                </Row>
                {entity.companyRegulators ? (
                    entity.companyRegulators.map(cr => (
                        <Row key={cr.code}>
                            <Col offset={2} xs={10}>
                                <p>{cr.name}</p>
                            </Col>
                            <Col>
                                <p>{cr.code}</p>
                            </Col>
                        </Row>
                    ))
                ) : (
                    <Row>
                        <Col offset={2} xs={10}>
                            -
                        </Col>
                        <Col>-</Col>
                    </Row>
                )}
            </Col>
        </Row>

        <Heading level={0} style={{ marginTop: 30 }}>
            Financial Info and nature of Business
        </Heading>
        <Row gutter={17}>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Financial Information
                </Heading>
                <Col offset={2} sm={10}>
                    <p {...style.title}>Total Assets:</p>
                    <p {...style.title}>Total Annual Revenue:</p>
                    <p {...style.title}>Fiscal Year End Date:</p>
                    <p {...style.title}>Source of Funds:</p>
                    <p {...style.title}>Source of Wealth:</p>
                </Col>
                <Col sm={10}>
                    <p>{entity.totalAssets || "Unknown"}</p>
                    <p>{entity.totalAnnualRevenue || "Unknown"}</p>
                    <p>{entity.fiscalYearEndDate || "Unknown"}</p>
                    <p>{entity.sourceOfFunds || "Unknown"}</p>
                    <p>{entity.sourceOfWealth || "Unknown"}</p>
                </Col>
            </Col>
            <Col md={12}>
                <Heading
                    level={1}
                    {...style.subheading}
                    style={{ marginBottom: 35 }}
                >
                    Nature of Business
                </Heading>
                <Col offset={2}>
                    <Row>
                        <Col sm={10}>
                            <p {...style.title}>Nature of Business:</p>
                            <p {...style.title}>
                                High Risk Industry Designation:
                            </p>
                            <p {...style.title}>Primary Industry Code:</p>
                            <p {...style.title}>Primary Industry Desc.:</p>
                        </Col>
                        <Col>
                            <p>{entity.natureOfBusiness || "Unknown"}</p>
                            <p>
                                {entity.highRiskIndustryDesignation ||
                                    "Unknown"}
                            </p>
                            <p>{entity.primaryIndustryCode || "Unknown"}</p>
                            <p>
                                {entity.primaryIndustryDescription || "Unknown"}
                            </p>
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={10}>
                        <Col {...style.title}>Industry Classifiers:</Col>
                    </Row>
                    <Row>
                        <Col xs={22}>
                            <hr {...style.divider} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={5}>
                            <p {...style.title}>Classification:</p>
                        </Col>
                        <Col sm={5}>
                            <p {...style.title}>Code:</p>
                        </Col>
                        <Col>
                            <p {...style.title}>Description:</p>
                        </Col>
                    </Row>
                    {entity.industryClassifiers ? (
                        entity.industryClassifiers.map(c => (
                            <Row key={c.code}>
                                <Col sm={5}>
                                    <p>{c.classifier}</p>
                                </Col>
                                <Col sm={5}>
                                    <p>{c.code}</p>
                                </Col>
                                <Col>
                                    <p>{c.description}</p>
                                </Col>
                            </Row>
                        ))
                    ) : (
                        <Row>
                            <Col sm={5}>
                                <p>-</p>
                            </Col>
                            <Col sm={5}>
                                <p>-</p>
                            </Col>
                            <Col>
                                <p>-</p>
                            </Col>
                        </Row>
                    )}
                </Col>
            </Col>
        </Row>
    </React.Fragment>
);

export default OrgViewer;
